export const colors = {
  primaryColor: "#231A3D",
  lowDensityPrimayColor: "#440F69",
  accentColor: "#0054E3",
  linkColor: "#4A90E2",
  whiteColor: "#ffffff",
  blackColor: "#000000",
  defaultFontColor: "#4A4A4A",
  baseBlue: "#436AB2",
  cardBackgroundColor: "#F1F3F6",
  neoPrimaryColor: "#002060",
  neoCardBgColor: "#F2E6FE",
  neoFontColor: "#4B006D",
  neoBlueFont: "#2354D4",
  newCardBgColor: "#F8EFFF",
  offwhiteColor: "#FDF2E1",
};

export const theme = {
  ...colors,
};
